import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isNil } from '@flowio/is';
import { stringify } from '@flowio/web-sdk';
import uniqueId from '../../utilities/uniqueId';
import { isMatchingOrigin, parseApplePayWindowMessage } from './utilities';

function postApplePayWindowMessage(targetWindow, message, origin, channelId) {
  targetWindow.postMessage("".concat(channelId, " ").concat(message), origin);
}
/**
 * @description Opens Apple Pay in a new window on pay.flow.io. Relies on the hosted page
 * provided by the @flowio/payment-callback app.
 */


export default function createWindowedApplePaySession(info, params) {
  var channelId = "apchannel".concat(uniqueId());
  return new Promise(function (resolve, reject) {
    var payFlowioOrigin = 'https://pay.flow.io';

    var windowParams = _objectSpread(_objectSpread({}, params), {}, {
      source_origin: window.location.origin,
      channel_id: channelId
    });

    var applePayWindow = window.open("".concat(payFlowioOrigin, "/payment/applepay/?").concat(stringify(windowParams)));

    if (applePayWindow !== null) {
      window.addEventListener('message', function (event) {
        if (isMatchingOrigin(event, payFlowioOrigin)) {
          var message = parseApplePayWindowMessage(event, channelId);

          if (!isNil(message)) {
            switch (message.type) {
              case 'APPLE_PAY_WINDOW_READY_MESSAGE':
                {
                  var parametersMessage = {
                    type: 'APPLE_PAY_WINDOW_PARAMETERS_MESSAGE',
                    payload: info
                  };
                  postApplePayWindowMessage(applePayWindow, JSON.stringify(parametersMessage), payFlowioOrigin, channelId);
                  return;
                }

              case 'APPLE_PAY_PAYMENT_RESULT_MESSAGE':
                resolve(message.payload);
                applePayWindow.close();
                break;

              default:
            }
          }
        }
      });
    } else {
      reject(new Error('Error opening Apple Pay window.'));
    }
  });
}
//# sourceMappingURL=windowed.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/payment_methods/applepay/windowed.js
// module id = 595
// module chunks = 0 1